var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusOutlined = function SvgPlusOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.53.375h.938c.084 0 .125.042.125.125v11c0 .083-.041.125-.125.125h-.937c-.084 0-.125-.042-.125-.125V.5c0-.083.041-.125.125-.125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.75 5.406h10.5c.083 0 .124.042.124.125v.938c0 .083-.041.125-.125.125H.75c-.083 0-.124-.042-.124-.125V5.53c0-.083.041-.125.125-.125Z"
  })));
};
export default SvgPlusOutlined;